module.exports = _.isFunction;